import { z } from 'zod'
import { ASSET_KIND, JOB_STATUS } from '../constants'

/** presigned URL 업로드 요청 */
export const presignUploadSchema = z.object({
  contentType: z.enum(['image/jpeg', 'image/png', 'image/webp']),
  size: z
    .number()
    .int()
    .positive()
    .max(20 * 1024 * 1024),
})
export type PresignUploadInput = z.infer<typeof presignUploadSchema>

/** 이미지·영상 생성 요청 */
export const generateAssetSchema = z.object({
  recipeId: z.string().min(1),
  kind: z.enum(ASSET_KIND),
  prompt: z.string().max(2000).optional(),
})
export type GenerateAssetInput = z.infer<typeof generateAssetSchema>

export const assetJobSchema = z.object({
  id: z.string(),
  recipeId: z.string(),
  kind: z.enum(ASSET_KIND),
  status: z.enum(JOB_STATUS),
  url: z.string().nullable(),
  error: z.string().nullable(),
  createdAt: z.string(),
})
export type AssetJob = z.infer<typeof assetJobSchema>
